import { Button } from '@/lib/Buttons';
import { FunctionComponent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

interface ISlideOverFooter {
  confirmLabel?: string;
  cancelLabel?: string;
  closeSlideOver?: () => void;
  onConfirmClicked: () => void;
  showCancelButton?: boolean;
  confirmIconLeft?: ReactNode;
  confirmIconRight?: ReactNode;
  cancelIconLeft?: ReactNode;
  cancelIconRight?: ReactNode;
}

export const SlideOverFooter: FunctionComponent<ISlideOverFooter> = ({
  cancelLabel,
  confirmLabel,
  closeSlideOver,
  onConfirmClicked,
  showCancelButton = true,
  confirmIconLeft,
  confirmIconRight,
  cancelIconLeft,
  cancelIconRight,
}) => {
  const { t } = useTranslation('COMMON');

  const shouldShowCancel = showCancelButton && closeSlideOver;

  return (
    <div className={twMerge('flex-shrink-0 px-4 py-4 flex', shouldShowCancel ? 'justify-evenly' : 'justify-center')}>
      {shouldShowCancel && (
        <Button type='button' intent='secondary' onClick={closeSlideOver}>
          <div className='flex items-center'>
            {cancelIconLeft && <span className='mr-2'>{cancelIconLeft}</span>}
            {cancelLabel || t('cancel')}
            {cancelIconRight && <span className='ml-2'>{cancelIconRight}</span>}
          </div>
        </Button>
      )}

      <Button type='button' className={shouldShowCancel && 'ml-4'} onClick={onConfirmClicked}>
        <div className='flex items-center'>
          {confirmIconLeft && <span className='mr-2 size-5 text-brand-300'>{confirmIconLeft}</span>}
          {confirmLabel || t('save')}
          {confirmIconRight && <span className='ml-2 size-5 text-brand-300'>{confirmIconRight}</span>}
        </div>
      </Button>
    </div>
  );
};
